import { FC } from "react";
import NewsCard from "../Shared/Common/Card/NewsCard";

import Innovation1 from "../../assets/images/innovation_careerarea.webp";
import OurCompany from "../../assets/images/our_company.webp";
import NissanHeritage from "../../assets/images/nissan_heritage.webp";

const news_card_props = {
  headerItems: {
    title: "page.common.more_from_nissan",
    href: "https://www.nissan-global.com/EN/",
    href_jp: "https://www.nissan-global.com/JP/",
    anchorText: "page.common.see_more",
    variant: "primary-outline",
    external: true,
    mobileView: true,
  },
  items: [
    {
      id: 1,
      name: "page.common.innovation",
      description: "page.innovation.description_1",
      src: Innovation1,
      href: "https://www.nissan-global.com/EN/INNOVATION/",
      href_jp: "https://www.nissan-global.com/JP/INNOVATION/",
    },
    {
      id: 2,
      name: "page.common.our_company",
      description: "page.know_more.description_2",
      src: OurCompany,
      href: "https://www.nissan-global.com/EN/COMPANY/",
      href_jp: "https://www.nissan-global.com/JP/COMPANY/",
    },
    {
      id: 3,
      name: "page.common.nissan_heritage",
      description: "page.know_more.description_3",
      src: NissanHeritage,
      href: "https://www.nissan-global.com/EN/HERITAGE/",
      href_jp: "https://www.nissan-global.com/JP/HERITAGE/",
    },
  ],
};
const Card: FC = () => {
  return (
    <div className="innovation-area">
      <NewsCard {...news_card_props} />
    </div>
  );
};
export default Card;
